import { AccountingCampaign } from "../gateway/AccountingCampaign/AccountingCampaign";

export const CAMPAIGN_INTERACTIONS = [
    "bannerView",
    "detailOpen",
    "ctaClick",
    "chatClick",
    "whatsappClick",
    "emailClick"
];

/**
 * Registro de interação com a faixa da Visão Geral. É "dispara e esquece": nunca lança, e a
 * falha não chega ao usuário. Devolve `true` só quando o back confirma que contou.
 */
export class RegisterCampaignInteractionUsecase {
    constructor() {
        this.AccountingCampaignGateway = new AccountingCampaign();
    }

    async execute({ accountingId = "", campaignId = "", interaction = "" } = {}) {
        const payload = this.sanitizeInput({
            accountingId,
            campaignId,
            interaction
        });
        if (!payload.accountingId || !payload.campaignId) return false;
        if (!CAMPAIGN_INTERACTIONS.includes(payload.interaction)) return false;

        try {
            const response =
                await this.AccountingCampaignGateway.registerInteraction(
                    payload.accountingId,
                    payload.campaignId,
                    payload.interaction
                );
            return response?.registered === true;
        } catch (error) {
            return false;
        }
    }

    sanitizeInput({ accountingId = "", campaignId = "", interaction = "" } = {}) {
        return {
            accountingId: String(accountingId ?? "").trim() || null,
            campaignId: String(campaignId ?? "").trim() || null,
            interaction: String(interaction ?? "").trim()
        };
    }
}
